export type PostJobQueryOpening = {
  id: string;
};

export type PostJobEntryPoint = 'sponsored_postings' | 'campaigns' | 'opening';

const POST_JOB_ENTRY_POINTS: readonly PostJobEntryPoint[] = [
  'sponsored_postings',
  'campaigns',
  'opening',
];

/**
 * Reads `/post-job?entryPoint=…`, which Hire adds so the posting flow knows
 * where it was launched. Null for any other value, and for source-ui's own
 * navigation, which starts the flow before it navigates.
 */
export function parsePostJobEntryPoint(
  search: string,
): PostJobEntryPoint | null {
  const entryPoint = new URLSearchParams(search).get('entryPoint');
  return POST_JOB_ENTRY_POINTS.find(value => value === entryPoint) ?? null;
}

/**
 * True when Hire asks source-ui to drop a stale posting session and start on
 * select-openings (`/post-job?fresh=1`).
 */
export function isPostJobFreshStart(search: string): boolean {
  return new URLSearchParams(search).get('fresh') === '1';
}

/**
 * Parses `/post-job?openingIds=…` for deep links from Hire.
 * Supports a single opening (primary Hire entry) or comma-separated lists.
 * Opening titles are loaded by source-ui after seed.
 */
export function parsePostJobQuery(
  search: string,
): PostJobQueryOpening[] | null {
  const params = new URLSearchParams(search);
  const openingIdsParam = params.get('openingIds');
  if (!openingIdsParam) {
    return null;
  }

  const ids = openingIdsParam
    .split(',')
    .map(id => id.trim())
    .filter(Boolean);
  if (ids.length === 0) {
    return null;
  }

  return ids.map(id => ({ id }));
}
